import useSWRImmutable from 'swr/immutable';

import { WHERE } from 'src/utils/firebase/firebase-manager';
import { getStores } from 'src/utils/firebase/firebase-short-cut';

const useSWRStores = (where?: WHERE[]) => {
  const {
    data: stores,
    isLoading,
    error,
    mutate,
  } = useSWRImmutable(where ? `stores-${where.join('-')}` : 'stores', () => getStores(where));

  return {
    stores,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRStores;
